// extracted by mini-css-extract-plugin
export default {"productFeatured":"bW-z","carousel":"cW-z","slides":"dW-z","slide":"eW-z","slideFeatured":"fW-z","zoomMode":"gW-z","fadeIn":"hW-z","imageSizing":"iW-z"};